import { Typography } from 'antd'
import React, { useMemo } from 'react'
import { useScenario } from '../../../../../../../features/scenario/queries/useScenario'
import { ReportGrammarRules } from '../../../../../../../redux/config/customReport/types'
import { NormalizedBuilderNode, NodesById, VisitorContext } from '../types'
import { NormalizedTitleVisitor } from '../normalizedVisitors/NormalizedTitleVisitor'
import SegmentList from '../../../print/SegmentList'

interface CategoryTitlePreviewProps {
  newTitle: string
  category: NormalizedBuilderNode
  rules: ReportGrammarRules
  context: VisitorContext
  nodesById: NodesById
}

const CategoryTitlePreview: React.FC<CategoryTitlePreviewProps> = ({
  newTitle,
  category,
  rules,
  context,
  nodesById
}) => {
  const budgetingScenario = useScenario({
    companyId: context.company,
    scenarioId: category.budgetingScenarioId
  })

  const segments = useMemo(() => {
    const previewNodes = {
      ...nodesById,
      [category.id]: { ...nodesById[category.id], title: newTitle, budgetingScenario }
    }
    const visitor = new NormalizedTitleVisitor(rules, previewNodes)
    return visitor.getTitleSegments(category.id)
  }, [nodesById, category.id, newTitle, budgetingScenario, rules])

  return (
    <Typography.Text style={{ whiteSpace: 'break-spaces' }}>
      <SegmentList segments={segments} />
    </Typography.Text>
  )
}

export default CategoryTitlePreview
